const VOICE_INTENT_CHANNEL_KEY = 'bunker:voice-intent-channel';

export function getVoiceIntentChannel(): string | null {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(VOICE_INTENT_CHANNEL_KEY);
}

export function hasVoiceIntent(channelId: string): boolean {
  return getVoiceIntentChannel() === channelId;
}

export function setVoiceIntent(channelId: string): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(VOICE_INTENT_CHANNEL_KEY, channelId);
}

export function clearVoiceIntent(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(VOICE_INTENT_CHANNEL_KEY);
}

let tabId: string | null = null;

/**
 * This page load, sent with every voice join. It lets the server tell this
 * tab coming back on a new connection (take its call over, media included)
 * from another tab of the same person (which evicts it). Random, never stored.
 */
export function voiceTabId(): string {
  if (!tabId) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    tabId = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  return tabId;
}
